import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedDate } from 'react-intl';

import colors from '@app/constants/colors';
import { Button } from '@app/components';

import { removeUserDevice } from '@app/actions/deviceActions';

class TableDevices extends React.Component {
  renderDevicesList = () => {
    const {
      devices, removeUserDevice, isDeviceRemoving, idRemovingDevice, isAllDevicesRemoving,
    } = this.props;

    return devices.map(({
      name = '-', type = '-', lastLoginDate, uniqueDeviceId,
    }) => {
      const isLoading = isDeviceRemoving && (idRemovingDevice === uniqueDeviceId);
      return (
        <tr key={uniqueDeviceId}>
          <td>{name}</td>
          <td>{type}</td>
          <td>
            <FormattedDate
              value={new Date(lastLoginDate * 1000)}
              month="short"
              year="numeric"
              day="numeric"
            />
          </td>
          <td>
            <Button
              labelId="devices.remove"
              textColor={colors.ALICE_BLUE}
              backgroundColor={colors.INTERNATIONAL_ORANGE}
              onClick={() => removeUserDevice(uniqueDeviceId)}
              loading={isLoading}
              disabled={isLoading || isAllDevicesRemoving}
            />
          </td>
        </tr>
      );
    });
  };

  render() {
    return (
      <TableResponsive>
        <Table>
          <thead>
            <tr>
              <th><FormattedMessage id="devices.deviceName" /></th>
              <th><FormattedMessage id="devices.deviceType" /></th>
              <th><FormattedMessage id="devices.lastLogin" /></th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            { this.renderDevicesList() }
          </tbody>
        </Table>
      </TableResponsive>
    );
  }
}

TableDevices.propTypes = {
  removeUserDevice: PropTypes.func.isRequired,
  isDeviceRemoving: PropTypes.bool.isRequired,
  idRemovingDevice: PropTypes.string.isRequired,
  isAllDevicesRemoving: PropTypes.bool.isRequired,
  devices: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProps = ({
  device: {
    devices, isDeviceRemoving, idRemovingDevice, isAllDevicesRemoving,
  },
}) => ({
  devices,
  isDeviceRemoving,
  idRemovingDevice,
  isAllDevicesRemoving,
});

const mapDispatchToProps = {
  removeUserDevice,
};

export default connect(mapStateToProps, mapDispatchToProps)(TableDevices);

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  
  & td, & th {
    border: 3px solid #FFFFFF;
  }
  & th {
    font-size : 1.3em;
    padding: 15px;
  }
  & td:not(:last-child) {
    font-size : 1em;
    text-align: center;
    padding: 15px;
    color: ${colors.SUPERNOVA};
  }
  & td:last-child {
    text-align: center;
    padding: 10px;
    min-width: 170px;
  }
  @media (max-width: 599px) {
    & td:not(:last-child), & td:last-child {
      padding: 25px 5px;
    }
  }
`;

const TableResponsive = styled.div`
  max-width: 880px;
  width: 100%;
  overflow-x: auto;
`;
